import { createActionTypes } from "../../../utils";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    ...createActionTypes("SUSCRIPTIONS", "FETCH_SUSCRIPTIONS_LIST" ),
}
